import { WorkOrder, WorkOrderFilters, WorkOrderWithAppointments } from "@myapp/contract";
import { useInfinitePaginated } from "../../../../shared/hooks/useInfinitePaginated";
import { workOrderKeys } from "../work-order.keys";
import { workOrderApi } from "../service";

export function useWorkOrdersInfiniteQuery(filters: WorkOrderFilters) {
  return useInfinitePaginated<WorkOrderFilters, WorkOrderWithAppointments>({
    queryKey: workOrderKeys.list(filters),
    params: filters,
    fetchFn: ({ page, ...rest }) =>
      workOrderApi.search({ ...rest, page }).then((response) => response.data),
    retry: false,
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });
}
